import React, { useEffect, useState } from 'react';
// helpers
import { getDate, getDateFromDateTimeLocal, getDatesBetweenDates, getDaysInMonth, isAvailableArray } from 'helpers';
// scss
import './Datepicker.scss';

const weekDays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];

const Datepicker = ({ handleSetDate, handleCancel, startDayInit, endDayInit, isStartDayBtnDisabled, isEndDayBtnDisabled, oneDate, min, max, inputName  }) => {
  // const { todayMonthIndex, todayYear } = useDate();
  const { todayMonthIndex, todayYear } = getDate(startDayInit || min);
  const [currentYear, setCurrentYear] = useState(todayYear);
  const [currentMonth, setCurrentMonth] = useState(todayMonthIndex + 1);
  const [currentMonthDatesList, setCurrentMonthDatesList] = useState(getDaysInMonth(currentMonth , currentYear));
  const [prevMonthEmptyDatesList, setPrevMonthEmptyDatesList] = useState([]);

  const [startDay, setStartDay] = useState(null);
  const [endDay, setEndDay] = useState(null);
  const [dates, setDates] = useState([]);

  const currentMonthBtnTitle = new Date(`${currentYear}, ${currentMonth}`)?.toLocaleString("uk-UA", { month: "long", year: "numeric", });

  function handleChangeMonth (btnName) {
    let step = 1;
    switch (btnName) {
      case "prev":
        setCurrentMonth((prev) => {
          if (prev === 1) {
            setCurrentYear((prev) => prev - step)
            return 12
          }
          return prev - step
        })
        break;
    
      default:
        setCurrentMonth((prev) => {
          if (prev === 12) {
            setCurrentYear((prev) => prev + step)
            return 1
          }
          return prev + step
        })
        break;
    }
  }

  function handleSelectDay (e, selectDate) {
    // if (oneDate) handleSetDate({startDay: selectDate})
    if (oneDate) handleSetDate({startDay: selectDate, inputName})

    if (!startDay && !endDay) {
      e.target.classList.add('active');
      setStartDay(selectDate);
    }
    if (startDay && !endDay) {
      if (selectDate === startDay) {
        e.target.classList.remove('active');
        setStartDay(null)
      } 
      if (selectDate > startDay) {
        e.target.classList.add('active');
        setEndDay(selectDate);
      }
      if (selectDate < startDay) {
        e.target.classList.add('active');
        setStartDay(selectDate);
        setEndDay(startDay);
      }
    }
    if (startDay && endDay) {
      if (selectDate === endDay) {
        e.target.classList.remove('active');
        setEndDay(null)
      }
      if (selectDate === startDay) {
        e.target.classList.remove('active');
        setStartDay(null)
      }
      else return
    }
    if (!startDay && endDay) {
      if (selectDate === endDay) {
        e.target.classList.remove('active');
        setEndDay(null)
      }
      if (selectDate > endDay) {
        e.target.classList.add('active');
        setStartDay(endDay);
        setEndDay(selectDate);
      }
      if (selectDate < endDay) {
        e.target.classList.add('active');
        setStartDay(selectDate);
      }
    }
  }

  function handleSubmit () {
    handleSetDate({startDay, endDay});
  }

  function handleClean() {
    if (oneDate) handleSetDate({startDay: "", inputName})
    handleSetDate({startDay: "", endDay: ""});
  }

  useEffect(() => {
    const currentMonthDates = getDaysInMonth(currentMonth, currentYear);
    setCurrentMonthDatesList(currentMonthDates);
    setPrevMonthEmptyDatesList(getPrevMonthEmptyDatesList(currentMonthDates[0]?.getDay()));
  }, [currentMonth, currentYear]);

  useEffect(() => {
    if (startDayInit && endDayInit) {
      setStartDay(startDayInit);
      setEndDay(endDayInit);
      setDates(getDatesBetweenDates(startDayInit, endDayInit)?.map(i => getDateFromDateTimeLocal(i)));
    }

    if (startDayInit && !endDayInit) {
      setStartDay(startDayInit);
    }
  }, [startDayInit, endDayInit]);

  useEffect(() => {
    if (startDay && endDay) setDates(getDatesBetweenDates(startDay, endDay)?.map(i => getDateFromDateTimeLocal(i)));
    else setDates([]);
  }, [startDay, endDay]);

  return (
    <div className="calendar">
      <div className="calendar__header">
        <p className="calendar__montn-year">{currentMonthBtnTitle}</p>
        <div className="calendar__btn-wrap">
          <button className="calendar__btn--prev" type='button' onClick={() => handleChangeMonth('prev')}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
            >
              <path
                d="M5.25195 0.908691L1.23969 4.93232L5.26331 8.94459"
                stroke="black"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button className="calendar__btn--next" type='button' onClick={() => handleChangeMonth('next')}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
            >
              <path
                d="M1.13232 0.908691L5.14459 4.93232L1.12096 8.94459"
                stroke="black"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="calendar__body">
        <div className="calendar__weekdays calendar-weekdays">
          <ul className="calendar-weekdays__list">
            {weekDays?.map((i, idx) => (
              <li key={idx} className="calendar-weekdays__item">
                {i}
              </li>
            ))}
          </ul>
        </div>
        <div className="calendar__days calendar-days">
          <ul className="calendar-days__list">
          {prevMonthEmptyDatesList?.map((i, idx) => (<li key={idx} className='calendar-days__item'></li>))}
            {currentMonthDatesList?.map((i, idx) => {
              const isStartDay = getDateFromDateTimeLocal(i) === startDay;
              const isEndDay = getDateFromDateTimeLocal(i) === endDay;
              // const isPastDay = today > i;
              let isMinMax = true;
              if (min) isMinMax = min <= getDateFromDateTimeLocal(i);
              const isBtnDisabled = !isMinMax;
              const isActiveLight = isAvailableArray(dates)?.includes(getDateFromDateTimeLocal(i)) ? "active-light" : "";
              const isActive = (isStartDay || isEndDay) ? 'active' : '';

              return (
                <li key={idx} className='calendar-days__item'>
                  <button className={`calendar-days__btn ${isActiveLight} ${isActive}`} disabled={isBtnDisabled} type="button" onClick={(e) => handleSelectDay(e, getDateFromDateTimeLocal(i))}>{i.getDate()}</button>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
      <div className="calendar__footer">
        <button className="calendar__btn--cancel" type="button" onClick={() => handleCancel(false)}>
          Скасувати
        </button>
        <button className="calendar__btn--clean" type="button" onClick={handleClean} disabled={!startDay && !endDay}>
          Очистити
        </button>
        <button className="calendar__btn--submit" type="button" onClick={handleSubmit} disabled={!startDay && !endDay}>
          Застосувати
        </button>
      </div>
    </div>
  );
};

export default Datepicker;

function getPrevMonthEmptyDatesList(dayIndex = 0) {
  if (dayIndex === 0) return new Array(6).fill("");

  return new Array(dayIndex - 1)?.fill("");
}